<template>
    <div>
        <!-- These results are for HOSPITALIZATION and LENS and DENTAL -->
        <div class="form-group row">
            <label for="socialSecurityRefund" class="col-9">{{ text.socialSecurityRefund }}</label>
            <div class="col-3 text-right">
                <p>{{ refundResults.socialSecurityRefundAmount + ' €' }}</p>
            </div>
        </div>
        <div class="form-group row">
            <label for="complementaryRefund" class="col-9">{{ text.complementaryRefund }}</label>
            <div class="col-3 text-right">
                <p>{{ refundResults.complementaryRefundAmount + ' €' }}</p>
            </div>
        </div>
        <div class="form-group row">
            <label for="leftToPay" class="col-9 font-weight-bold">{{ text.leftToPay }}</label>
            <div class="col-3 text-right">
                <p><strong>{{ refundResults.leftToPayAmount + ' €' }}</strong></p>
            </div>
        </div>
    </div>
</template>

<script>
import resources from '../helpers/resources'
import Branding from '../helpers/branding'

export default {
    data() { return { text : resources } },
    computed: {
        refundResults () { return this.$store.state.refundResults },
        leftToPayClass () { return Branding.getLeftToPayClass() }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SimpleResults.vue